(function () {
    var THRESHOLD = 40;
    var headers = document.querySelectorAll('[data-bm-header]');
    if (!headers.length) return;
  
    function syncScroll(header) {
      if (header.getAttribute('data-overlay') !== 'true') {
        header.classList.add('is-solid');
        return;
      }
      header.classList.toggle('is-solid', window.scrollY > THRESHOLD);
    }
  
    function syncAll() {
      headers.forEach(syncScroll);
    }
  
    function syncOffset() {
      headers.forEach(function (header) {
        if (header.classList.contains('bm-header--overlay')) return;
        document.documentElement.style.setProperty('--bm-header-offset', header.offsetHeight + 'px');
      });
    }

    syncAll();
    syncOffset();
    window.addEventListener('scroll', syncAll, { passive: true });
    window.addEventListener('resize', syncOffset);

    if (window.ResizeObserver) {
      var offsetObserver = new ResizeObserver(syncOffset);
      headers.forEach(function (header) {
        if (!header.classList.contains('bm-header--overlay')) offsetObserver.observe(header);
      });
    }
  
    function setCount(count) {
      var value = Number(count) || 0;
      headers.forEach(function (header) {
        var countEl = header.querySelector('[data-bm-cart-count]');
        var cartLink = header.querySelector('[data-bm-cart]');
        var label = header.getAttribute('data-cart-label') || 'Cart';
        if (countEl) {
          countEl.textContent = String(value);
          countEl.classList.toggle('is-empty', value === 0);
        }
        if (cartLink) {
          var name = label;
          if (value === 1) name = label + ', 1 item';
          else if (value > 1) name = label + ', ' + value + ' items';
          cartLink.setAttribute('aria-label', name);
        }
      });
    }
  
    function refreshCart() {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var url = root.charAt(root.length - 1) === '/' ? root + 'cart.js' : root + '/cart.js';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function (cart) {
          if (cart && typeof cart.item_count === 'number') setCount(cart.item_count);
        })
        .catch(function () {});
    }
  
    ['cart:refresh', 'cart:updated', 'cart:change', 'theme:cart:change'].forEach(function (name) {
      document.addEventListener(name, refreshCart);
    });
  
    if (!window.__bmHeaderFetchPatched && window.fetch) {
      window.__bmHeaderFetchPatched = true;
      var originalFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var result = originalFetch(input, init);
        var requestUrl = '';
        if (typeof input === 'string') requestUrl = input;
        else if (input && input.url) requestUrl = input.url;
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(requestUrl)) {
          result.then(function (response) {
            if (response && response.ok) refreshCart();
          }).catch(function () {});
        }
        return result;
      };
    }
  })();
  